import { VentasAgrupadas } from "./VentasPorClientes"

const areaReport = {
    route: 'un',
    endpoint: 'area',
    title: 'Ventas por unidad de negocio',
    question: '¿Qué líneas generan más ventas, cuánto aportan al total y qué margen dejan?',
    count: 'Unidades con ventas',
    chart: 'Unidades con más ventas',
    search: 'Buscar unidad de negocio',
    column: 'Unidad de negocio',
    empty: 'No hay unidades que coincidan con la búsqueda.',
}

export const VentasPorUnidadNegocio = () => <VentasAgrupadas config={areaReport} />
